import { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";

export const PageImg = ({ src, className }) => {
  const [tries, setTries] = useState(0);
  const [ok, setOk] = useState(false);
  useEffect(() => { setTries(0); setOk(false); }, [src]);
  const retry = () => { if (tries < 24) setTimeout(() => setTries((t) => t + 1), 5000); };
  const url = `${src}${src.includes("?") ? "&" : "?"}r=${tries}`;
  return (
    <div className={`relative ${className}`}>
      {!ok && <div className="absolute inset-0 flex items-center justify-center bg-stone-50 text-[10px] text-stone-400"><Loader2 size={14} className="mr-1 animate-spin" />Preparing PDF…</div>}
      <img data-testid="page-img" alt="" loading="lazy" src={url} onLoad={() => setOk(true)} onError={retry} className={`h-full w-full object-contain bg-white ${ok ? "" : "opacity-0"}`} />
    </div>
  );
};
